import { render, staticRenderFns } from "./InspirationDetails.vue?vue&type=template&id=39933eec"
import script from "./InspirationDetails.vue?vue&type=script&lang=ts"
export * from "./InspirationDetails.vue?vue&type=script&lang=ts"
import style0 from "./InspirationDetails.vue?vue&type=style&index=0&id=39933eec&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports